import { Component, Inject, OnInit } from '@angular/core';
import { SharedDataService } from '../../shared-data.service'
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-img-previewer',
  templateUrl: './img-previewer.component.html',
  styleUrls: ['./img-previewer.component.scss']
})
export class ImgPreviewerComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      url:string,
      Person_Name:string
      oldurl:string
    },
    // private SharedDataService:SharedDataService
  ) { }

  ngOnInit() {
    this.getImageDimensions(this.data.url).then(succ=>this.imgProperties=succ)
  }

  isGettingImage:boolean
  imgProperties:{
    width:number
    height:number
    name:string
  }

  public getImageDimensions(url: string): Promise<{ width: number; height: number; name:string }> {
    this.isGettingImage=false
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      
      img.onload = () => {
        const urlParts = url.split('/');
        const imageName = urlParts[urlParts.length - 1];
        const dimensions = {
          width: img.width,
          height: img.height,
          name: imageName
        };
        resolve(dimensions);
        this.isGettingImage=true
      };

      img.onerror = (error) => {
        reject(error);
        this.isGettingImage=true
      };
    });
  }

  downloadthis(url){
    const link = document.createElement('a');

    // Set the href attribute to the image URL
    link.href = url;
  
    // Set the download attribute to specify the desired file name
    link.download = this.data.Person_Name;
  
    // Create a click event
    const clickEvent = new MouseEvent('click');
  
    // Dispatch the click event on the link element
    link.dispatchEvent(clickEvent);
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/img-previewer/img-previewer.component.ts